import KendoMap from '../KendoMap'
import KendoMapMarker from '../KendoMapMarker'
import KendoMapLayer from '../KendoMapLayer'

let KendoMapInstaller = class {
    static install(Vue) {
        Vue.component(KendoMap.name, KendoMap)
        Vue.component(KendoMapMarker.name, KendoMapMarker)
        Vue.component(KendoMapLayer.name, KendoMapLayer)
    }
}

export default KendoMapInstaller

// Automatic installation if Vue has been added to the global scope.
if (typeof window !== 'undefined' && window.Vue && window.Vue.use) {
    window.Vue.use(KendoMapInstaller)
}


// WEBPACK FOOTER //
// ./packages/kendo-map-vue-wrapper/src/kendo-map-installer/index.js